import { IconKey,IconUserSearch } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconUserSearch
};
//

const Recon = {

    id: 'authentication',
    title: 'Mandate',
    type: 'group',
    display_id:'U',
    icon: icons.IconUserSearch,
    children: [
        {
            id: 'mandate',
            title: 'Mandate',
            type: 'item',
            display_id:104,
            url: '/Admin/mandate',
            breadcrumbs: false
        },
        {
            id: 'surrender',
            title: 'Surrender Request',
            type: 'item',
            display_id:105,
            url: '/Admin/surrender',
            breadcrumbs: false
        },
    ]
}

export default Recon;
